import ReactDOM from 'react-dom/client'
import App from './App'
import './index.less'
import { authConfig, rootPath } from 'shared/auth/auth.config'
import { initialiseSentry, registerServiceWorker } from 'Utils/common.utils.ts'
import { Authenticate, AuthProvider } from 'shared/auth/auth.utils'
import { CookieSync } from 'react-ai-platform-auth'
import { DomainRedirect } from 'Components/common/DomainRedirect/DomainRedirect'
import { cvRefreshTokenCookieName, tiaiDomain } from 'shared/auth/auth.constants'
import { appConfig } from 'Config/app-config'

registerServiceWorker()
initialiseSentry()

const refreshTokenCookieDomain = window.origin.endsWith(tiaiDomain) ? tiaiDomain : ''

ReactDOM.createRoot(document.getElementById('root')!).render(
    <DomainRedirect>
        <CookieSync
            config={{
                cookieSyncRefreshToken: cvRefreshTokenCookieName,
                cookieSyncDomain: refreshTokenCookieDomain,
            }}
        >
            <AuthProvider
                config={{
                    ...authConfig,
                    defaultLogoutRedirectUrl: `${rootPath}/logout?redirect=${appConfig.ftsClientBaseUrlAi}`,
                }}
            >
                <Authenticate>
                    <App />
                </Authenticate>
            </AuthProvider>
        </CookieSync>
    </DomainRedirect>
)
